module.exports = __webpack_public_path__ + "static/media/kuchnia-1-min.4d0063e8.png";